import { DependencyTypes } from "../../../constants/dependencyTypes";
import { isDateValid } from "../../../modules/definition/calendar/dateFunctions";

const isFsDependencyViolated = (subject, object) => {
  // Finish to Start: Object start date must be greater than subject end date
  if (isDateValid(object.startDate) && !isDateValid(subject.endDate)) {
    // If either does not have a date yet, then the constraint is violated
    return true;
  } else if (!isDateValid(object.startDate)) {
    return false;
  }
  const objectStart = object.startDate.timestamp;
  const subjectEnd = subject.endDate.timestamp;
  return objectStart < subjectEnd;
};

const isSsDependencyViolated = (subject, object) => {
  // Start to Start: Object start date must be greater than subject start date
  if (isDateValid(object.startDate) && !isDateValid(subject.startDate)) {
    // If either does not have a date yet, then the constraint is violated
    return true;
  } else if (!isDateValid(object.startDate)) {
    return false;
  }
  const objectStart = object.startDate.timestamp;
  const subjectStart = subject.startDate.timestamp;
  return objectStart < subjectStart;
};
const isFfDependencyViolated = (subject, object) => {
  // Finish to finish: Object end date must be greater than subject end date
  if (isDateValid(object.endDate) && !isDateValid(subject.endDate)) {
    // If either does not have a date yet, then the constraint is violated
    return true;
  } else if (!isDateValid(object.startDate)) {
    return false;
  }
  const objectEnd = object.endDate.timestamp;
  const subjectEnd = subject.endDate.timestamp;
  return objectEnd < subjectEnd;
};
const isSfDependencyViolated = (subject, object) => {
  // Start to Finish: Object finish date must be greater than subject start date
  if (isDateValid(object.endDate) && !isDateValid(subject.startDate)) {
    // If either does not have a date yet, then the constraint is violated
    return true;
  } else if (!isDateValid(object.startDate)) {
    return false;
  }
  const objectEnd = object.endDate.timestamp;
  const subjectStart = subject.startDate.timestamp;
  return objectEnd < subjectStart;
};

// Given a subject, object, dependencyType, and offset...
// Work out if we currently meet the conditions of this dependency or not!
export const isDependencyViolated = (dependency, itemDates) => {
  // console.log(`isDependencyViolated(): dependency = ${dependency}, itemDates = ${itemDates}`);
  // if (!itemDates || !itemDates.get) {
  //   console.log(`itemDates or itemDates.get does not exist`);
  // }

  const dependencyType = dependency.dependencyType;
  const subject = itemDates.get(dependency.subject);
  const object = itemDates.get(dependency.object);
  switch (dependencyType) {
    case DependencyTypes.FS:
      return isFsDependencyViolated(subject, object);
    case DependencyTypes.SS:
      return isSsDependencyViolated(subject, object);
    case DependencyTypes.FF:
      return isFfDependencyViolated(subject, object);
    case DependencyTypes.SF:
      return isSfDependencyViolated(subject, object);
    default:
      return false;
  }
};
